<template>
    <div class="wrapper">
        <imcHeader
			:name="userName"
            v-if="this.$route.name !=='ExterIndex'"
			:env="env">
            <tenant-switch
                :tenant-id="tenantId"
                :tenant-name="tenantName"
                :tenants-list="tenantsList"
                @cutTenant="cutTenant" />
        </imcHeader>
        <router-view v-if="tenantReady"></router-view>
    </div>
</template>

<script>
import watermark from 'watermark';
import { getUserInfo, getTenantList } from '../network'
import { getCookie } from '../util/cookie-util'
import TenantSwitch from '@/components/common/TenantSwitch'

export default {
    name: 'home',
    components: {
        TenantSwitch,
    },
    data: function() {
        return {
            userName: '',
            env: getCookie('ENV') || 'dev',
            tenantsList: [],
            tenantName: '',
            tenantId: '',
            tenantReady: false,
        }
    },
    created(){
        this.getUserInfo()
        this.loadTenants()
    },
    methods: {
        loadTenants() {
            getTenantList().then((res) => {
                const list = this.normalizeTenants(res.data.data)
                if (!list.length) {
                    this.tenantReady = true
                    return
                }
                this.tenantsList = list
                const savedTid = localStorage.getItem('tid')
                const activeTenant = list.find((item) => item.id === savedTid) || list[0]
                this.tenantId = activeTenant.id
                localStorage.setItem('tid', this.tenantId)
                this.setTenantsInfo()
                this.tenantReady = true
            }).catch(() => {
                this.tenantReady = true
            })
        },
        normalizeTenants(data) {
            const list = Array.isArray(data) ? data : []
            return list.reduce((tenants, item = {}) => {
                const id = item.systemId
                const name = item.name
                if (id && name) {
                    tenants.push({ id, name })
                }
                return tenants
            }, [])
        },
        cutTenant(value) {
            if (!value || value === this.tenantId) return
            this.tenantId = value
            localStorage.setItem('tid', value)
            this.setTenantsInfo()
            window.location.reload()
        },
        setTenantsInfo() {
            const activeTenant = this.tenantsList.find((item) => item.id === this.tenantId) || this.tenantsList[0]
            this.tenantName = activeTenant ? activeTenant.name : ''
        },
        // 登录获取基本信息接口
        getUserInfo() {
            getUserInfo().then((res)=>{
                let data = res.data;
                if(data.code === 'S00000'){
                    this.userName = data.data.employeeName
                    watermark('.wrapper', (data.data.employeeCode || (window.location.hostname.indexOf('aitongqian') !== -1 ? 'aitongqian' : 'guazi')));

                }
            })
        },
    },
}
</script>

<style>
html,
body,
#app{
    height:100%;
    width:100%;
    background:#f2f4f6;
}
.wrapper{
    width: 100%;
    min-height: 100%;
}

</style>
<style lang="scss">
.wrapper{
    .van-calendar__selected-day{
        background-color:#05B555;
        border-radius: 50%;
        width: 36px;
        height: 36px;
    }
    .van-calendar__selected-day, 
    .van-button--danger{
        background-color:#05B555;
        border-color: #05B555;
    }
    .van-popup{
        border-radius: 12px 12px 0 0;
    }
    .van-calendar__header-subtitle{
        color: #222;
    }
    /* .van-calendar__day{
        height: 45px;
    } */
}

</style>
